import { Component, OnInit,Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { IstSummaryService } from '../../../../services/ist/ist-summary.service';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { Subject } from 'rxjs';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-study-team-add-or-role',
  templateUrl: './ist-study-team-add-or-role.component.html',
  styleUrls: ['./ist-study-team-add-or-role.component.scss']
})
export class IstStudyTeamAddOrRoleComponent implements OnInit {

  @Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  organizationOptions = [];
  roleOptions = [];
  ApplicationID: any;
  studyTeamAddOrgRole: UntypedFormGroup;
  RoleName: string = "";
  MemberOrganizationName: string = "";
  organizationgrayout: boolean = true;
  staticformFields: any;

  constructor(public modalRef: NgbActiveModal,
    private summaryService: IstSummaryService,
    private istDatashareserivse: IstDataShareService,
    private modalService: NgbModal,
    private commonservice: CommonService
  ) { }

  getStaticFiledsData(screenCode: string) {
    this.commonservice.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  ngOnInit() {
    this.istDatashareserivse.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.studyTeamAddOrgRole = new UntypedFormGroup({
      organization: new UntypedFormControl(""),
      role: new UntypedFormControl(""),
    });

    this.GetMasterData();
    if (this.Content.heading == "view" || this.Content.heading == "Edit") {
      this.studyTeamAddOrgRole.patchValue({
        organization: this.Content.content.MemberOrganizationId,
        role: this.Content.content.RoleId
      });
      this.MemberOrganizationName = this.Content.content.OrganizationName;
      this.RoleName = this.Content.content.RoleName;
      this.studyTeamAddOrgRole.controls["organization"].disable();
      this.organizationgrayout = true;
    }
    else {
      this.studyTeamAddOrgRole.controls["organization"].enable();
      this.organizationgrayout = false;
    }

    if (this.Content.content.staticformFields && this.Content.content.staticformFields.length > 0) {
      this.staticformFields = this.Content.content.staticformFields;
    }
    else {
      this.getStaticFiledsData('SCR-002');
    }
  }

  GetCurrentMapping() {
    this.summaryService.masterData("api/ISTStudyTeam/GetMappingDetails?ID=" + this.Content.content.id).subscribe(summary => {
      this.studyTeamAddOrgRole.patchValue({
        MemberOrganizationID: summary["organization"],
        RoleID: summary["role"]
      });
    });
  }

  GetMasterData() {
    this.summaryService.masterData("api/ISTStudyTeam/GetMasterData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.Content.content.id).subscribe(summary => {
      this.roleOptions = summary["MasterData2"];
    //  this.roleOptions = [{ label: "Select", value: "", checked: true }].concat(this.roleOptions);
      this.organizationOptions = summary["MasterData1"];
     // this.organizationOptions = [{ label: "Select", value: "", checked: true }].concat(this.organizationOptions);
    });
  }

  getOrganizationName(event) {
    // debugger;
    this.MemberOrganizationName  =""
    let id= event.target.value;

    let obj=this.organizationOptions.filter(function(item){
      return item.value==id;
    })[0];
    if(obj!=null && obj!=undefined && obj != "")
    {
      this.MemberOrganizationName = obj.label;
    }
  }

  getRoleName(event) {
    // debugger;
    this.RoleName = "" ;
    let id= event.target.value;
    let obj=this.roleOptions.filter(function(item){
      return item.value==id;
    })[0];
    if(obj!=null && obj!=undefined && obj != "")
    {
      this.RoleName = obj.label;
    }

  }

  SaveRoleOrgMap() {
    if (this.validateControls()) {
      //debugger
      var formData = this.studyTeamAddOrgRole.value;
      let isOrgExist = this.Content.content.rowDataRoles.findIndex(
        (r: any) => r.MemberOrganizationId == this.studyTeamAddOrgRole.controls["organization"].value);
      if (isOrgExist != -1) {
        let message = "";
        if (this.Content.heading != "Edit") {
          message += "A role is already added against this organization. Please select another organization <br/>";
          //this.MemberOrganizationName + " already added organization <br/>";
          this.commonservice.ValidationBanner(message);
        }
        else {
          let isOrgDExist = this.Content.content.rowDataRoles.findIndex(
            (r: any) => r.MemberOrganizationId == this.studyTeamAddOrgRole.controls["organization"].value && r.RoleId == this.studyTeamAddOrgRole.controls["role"].value);
          if (isOrgDExist != -1) {
          //  message += "No changes have been performed.<br/>";
          //  this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
            this.modalRef.dismiss();
          }
          else {
            let obj = {
              "MemberOrganizationId": this.studyTeamAddOrgRole.controls["organization"].value, "MemberOrganizationName": this.MemberOrganizationName,
              "RoleId": this.studyTeamAddOrgRole.controls["role"].value, "RoleName": this.RoleName
            };
           // this.action.next(obj);
            this.modalRef.close(obj);
          }
        }
      }
      else {
        let obj = {
          "MemberOrganizationId": this.studyTeamAddOrgRole.controls["organization"].value, "MemberOrganizationName": this.MemberOrganizationName,
          "RoleId": this.studyTeamAddOrgRole.controls["role"].value, "RoleName": this.RoleName
        };
        //this.action.next(obj);
        this.modalRef.close(obj);
      }
    }
  }
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.studyTeamAddOrgRole.value;

    if (this.staticformFields?.StudyTeam_Org.IS_Display && this.staticformFields?.StudyTeam_Org.IS_MANDATORY) {
      if (formData.organization === null || formData.organization === "") {
        $("#organization").addClass("ng-touched ng-invalid validate-error");
        $("#organization").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.StudyTeam_Org.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#organization").addClass("ng-untouched ng-valid");
        $("#organization").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.StudyTeam_UserRole.IS_Display && this.staticformFields?.StudyTeam_UserRole.IS_MANDATORY) {
      if (formData.role === null || formData.role === "") {
        $("#role").addClass("ng-touched ng-invalid validate-error");
        $("#role").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.StudyTeam_UserRole.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#role").addClass("ng-untouched ng-valid");
        $("#role").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (!isValid)
      this.commonservice.ValidationBanner(message);
    return isValid;
  }

  Close(){
   this.canExit().then((x)=>{
      this.modalRef.dismiss();
   });
  }
  canExit() {
    if (this.studyTeamAddOrgRole.dirty && this.Content.heading =='Edit') {
      return this.commonservice.CanDeactivateBanner();
    }
    else {
     return Promise.resolve(true);
    }

  }
}
